/** `leaveTeam` translations, for every locale -- the Supervisees tab of Leave. */
export const leaveTeam = {
  mn: {
    leaveTeam: {
      people: 'Ажилтнууд',
      all: 'Бүгд',
      allRequests: 'Бүх хүсэлт',
      awaiting: 'Таны шийдвэр хүлээж буй: {{count}}',
      noneListed: 'Чөлөө авах ажилтан алга',
      capped: 'Сүүлийн {{count}} хүсэлтийг харуулж байна. Бүх хүсэлтийг нь харахын тулд ажилтныг сонгоно уу.',
      awaitingCut: 'Шийдвэр хүлээж буй {{total}} хүсэлтээс хамгийн сүүлийн {{shown}}-г харуулж байна.',
      awaitingCutUnknown: 'Шийдвэр хүлээж буй хамгийн сүүлийн {{shown}} хүсэлтийг харуулж байна; үүнээс олон байж магадгүй.',
    },
  },
  en: {
    leaveTeam: {
      people: 'People',
      all: 'All',
      allRequests: 'All requests',
      awaiting: 'Awaiting you: {{count}}',
      noneListed: 'Nobody here takes leave',
      capped: 'Showing the newest {{count}} requests. Choose a person to see all of theirs.',
      awaitingCut: 'Showing the newest {{shown}} of {{total}} requests awaiting a decision.',
      awaitingCutUnknown: 'Showing the newest {{shown}} requests awaiting a decision; there may be more.',
    },
  },
  ru: {
    leaveTeam: {
      people: 'Сотрудники',
      all: 'Все',
      allRequests: 'Все заявки',
      awaiting: 'Ждут вашего решения: {{count}}',
      noneListed: 'Здесь никто не берёт отпуск',
      capped: 'Показаны последние {{count}} заявок. Выберите сотрудника, чтобы увидеть все его заявки.',
      awaitingCut: 'Показаны последние {{shown}} из {{total}} заявок, ожидающих решения.',
      awaitingCutUnknown: 'Показаны последние {{shown}} заявок, ожидающих решения; их может быть больше.',
    },
  },
} as const
